/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.SelfCheckInKioskSettings {
    angular.module('meevo.plugins.selfCheckInKioskSettings', []);
}
